import {findAll, onReady} from "../../../../../modules/vegas/js/util";
import YandexMapLoader from "./YandexMap";
import VGMap from "./vgmap";
import VGMapRoute from "./route";

function ready() {
	[...findAll('[data-vg-map]')].map(function (map) {
		new YandexMapLoader().loadIfVisible(function (){
			VGMap.init(map);
		});
	});

	let mapRoute = document.querySelector('#map-route');
	if (mapRoute) {
		new YandexMapLoader().load(function (){
			VGMap.init('map-route', {
				callback: {
					afterInitMap: function (map, params, _this) {
						VGMapRoute.run(map, params, _this);
					}
				}
			});
		});
	}
}

onReady(ready);
typeof onTurboRender !== 'undefined' && onTurboRender(ready);
